import React from 'react';
import styles from './Dashboard.module.css';

const Dashboard = () => {
    return (
        <div className={ styles.container }>
            Dashboard
        </div>
    )
}

export default Dashboard;